/* eslint-disable camelcase */
<template>
  <span>
    <div style="display:flex;flex-wrap:wrap; padding:10px;" class="bloc">
      <div>{{ this.liens.event }}</div>
      <div style="margin-left:auto;">
        <button class="button is-primary" @click="handleclick">
          {{ $t("attendees.show") }}
        </button>
      </div>
    </div>

    <div
      class="textit_background_home has-text-centered"
      :style="this.background"
    >
      <div class="container">
        <div
          class="has-text-danger"
          v-if="this.type_visualisation == 'moderateur'"
        >
          {{ $t("evenement.animateur") }}
        </div>
        <a
          :href="URL(lien[2], lien[1], lien[0])"
          target="_blank"
          v-for="(lien, key) in this.liens.links"
          :key="key"
        >
          <div class="meeting">
            <img
              class="image is-48x48 is-pulled-left"
              :src="'/static/logosAppli/logo-' + lien[2] + '.png'"
            />
            <span class="meetingName">{{ lien[0].split("¤", 3)[0] }}</span>
            <div class="clearfix"></div>
          </div>
        </a>
      </div>
      <Footer v-if="!this.$store.getters.iframeColidee" :window="window" />
    </div>
  </span>
</template>

<script>
import axios from "axios";
import Footer from "@/components/layout/Footer";

export default {
  data() {
    return {
      window: {
        width: window.innerWidth
      },
      shortcut: this.$route.params.shortcut,
      shortcut_moderateur: this.$route.params.shortcut_moderateur,
      type_visualisation: "",
      liens: "",
      url_event: process.env.URL_MEDIA,
      background: "",
      url_tools: {
        brainstorming: process.env.URL_TOOL_BRAINSTORMING,
        textit: process.env.URL_TOOL_TEXTIT,
        sondage: process.env.URL_TOOL_SONDAGE,
        profeel: process.env.URL_TOOL_PROFEEL,
        quizz: process.env.URL_TOOL_QUIZZ
      }
    };
  },
  components: {
    Footer
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    if (this.shortcut) {
      axios
        .get(process.env.URL_SSO_API + "shortcut/public/event/null/null/" + this.shortcut)
        .then(response => {
          this.type_visualisation = "public";
          this.liens = response.data;
          if (response.data.media) {
            this.background =
              "background-image:url('" +
              this.url_event +
              response.data.media +
              "')";
          }
          if (response.data.state===1) {
            if (
              (response.data.open_at !== "1970-01-01 00:00:00" &&
                response.data.open_at !== null) ||
              (response.data.close_at !== "1970-01-01 00:00:00" &&
                response.data.close_at !== null)
            ) {
              if (
                response.data.open_at !== "1970-01-01 00:00:00" &&
                response.data.open_at !== null &&
                new Date(response.data.open_at.replace(" ", "T")) >= new Date()
              ) {
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: this.$i18n.t("toast.reunion_invalide")
                });
                this.$router.push({ name: "home" });
              } else if (
                response.data.close_at !== "1970-01-01 00:00:00" &&
                response.data.close_at !== null &&
                new Date(response.data.close_at.replace(" ", "T")) <= new Date()
              ) {
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: this.$i18n.t("toast.reunion_invalide")
                });
                this.$router.push({ name: "home" });
              }
            }
          } else {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.reunion_invalide")
            });
            this.$router.push({ name: "home" });
          }
          this.type_visualisation = "public";
          this.liens = response.data;
          if (response.data.media) {
            this.background =
              "background-image:url('" +
              this.url_event +
              response.data.media +
              "')";
          }
        })
        .catch(error => {
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.reunion_invalide")
          });
          this.$router.push({ name: "home" });
        });
    }

    if (this.shortcut_moderateur) {
      axios
        .get(
          process.env.URL_SSO_API +
            "shortcut/moderateur/event/null/null/" +
            this.shortcut_moderateur
        )
        .then(response => {
          this.type_visualisation = "moderateur";
          this.liens = response.data;
          if (response.data.media) {
            this.background =
              "background-image:url('" +
              this.url_event +
              response.data.media +
              "')";
          }
        })
        .catch(error => {
          // this.$buefy.toast.open({
          //   type: "is-danger",
          //   message: this.$i18n.t("toast.reunion_invalide")
          // });
          // this.$router.push({ name: "home" });
        });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    changerReunion() {
      window.location = "/";
    },
    handleclick() {
      if (this.shortcut_moderateur) {
        this.$router.push(`attendees/${this.shortcut_moderateur}.htm`);
      } else {
        this.$router.push(`attendees/${this.shortcut}.htm`);
      }
    },
    URL(tool, code, tool_id) {
      var url = "";
      var url_moderation = "";
      if (tool === "brainstorming") {
        url = this.url_tools.brainstorming + "/board/p-" + code;
        url_moderation = this.url_tools.brainstorming + "/board/a-" + code;
      }
      if (tool === "textit") {
        url = this.url_tools.textit + "/p-" + code;
        url_moderation = this.url_tools.textit + "/a-" + code;
      }
      if (tool === "sondage") {
        url = this.url_tools.sondage + "/p-" + code;
        url_moderation = this.url_tools.sondage + "/resultats-" + code;
      }
      if (tool === "quizz") {
        url = this.url_tools.quizz + "/i-" + code;
        url_moderation = this.url_tools.quizz + "/resultats-" + code;
      }
      if (tool === "profeel") {
        url = this.url_tools.profeel + "/i-" + code;
        url_moderation =
          this.url_tools.profeel + "/resultats-" + code + "/resultatGroup";
      }
      if (tool === "custom") {
        url = tool_id.split("¤", 3)[1];
        url_moderation = tool_id.split("¤", 3)[1];
      }
      if (this.type_visualisation === "public") {
        return url;
      }
      if (this.type_visualisation === "moderateur") {
        return url_moderation;
      }
    }
  }
};
</script>

<style scoped>
.meetingName {
  color: #3a3a3a;
  margin-top: 8px;
  display: block;
}

.textit_background_home {
  min-height: calc(100% - 60px);
  background: #e6ecf0;
  /* background-image: url("~@/assets/img/public_background_home.png"); */
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  padding: 50px 0;
}

.meeting {
  max-width: 450px;
  margin: 15px auto;
  /*border:1px gray solid;*/
  padding: 5px;
  text-align: left;
  background: #fff;
  border-radius: 5px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
}

.meeting img {
  margin-right: 10px;
}

.button {
  border: 1px solid white;
}
.clearfix {
  clear: both;
}

.cartouchePublic a {
  color: #f8df40;
}
.cartouchePublic {
  background: #424a60;
  color: white;
  text-align: left;
  padding: 5px;
  font-size: 1.5em;
  z-index: 1000;
  position: relative;
}

#buttonPageAttendees,
#buttonPageAttendees button {
  top: 10px;

  position: absolute;

  z-index: 10000;

  right: 5px;
}

.cartouchePublic img {
  height: 45px;
  vertical-align: middle;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Portail.vue